import { Button } from './Button';
import styles from './InlineConfirm.module.css';

interface InlineConfirmProps {
	message: string;
	confirmLabel?: string;
	onConfirm: () => void;
	onCancel: () => void;
	destructive?: boolean;
}

export function InlineConfirm({
	message,
	confirmLabel = 'Confirm',
	onConfirm,
	onCancel,
	destructive = false,
}: InlineConfirmProps) {
	return (
		<div className={styles.confirmWrapper}>
			<p className={styles.message}>{message}</p>
			<div className={styles.actions}>
				<Button variant="secondary" onClick={onCancel}>
					Cancel
				</Button>
				<Button variant={destructive ? 'destructive' : 'primary'} onClick={onConfirm}>
					{confirmLabel}
				</Button>
			</div>
		</div>
	);
}
